module.exports = __webpack_public_path__ + "static/img/icon_wk.29e93a02.png";